<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-form>
          <v-card-title class="toolbar primary white--text">
            <v-icon dark>
              note_add
            </v-icon>
            <h3
              class="title ml-2"
            >
              Send Yield Emails
            </h3>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="isVisible = false"
            >
              X
            </v-btn>
          </v-card-title>
          <v-progress-linear
            v-if="isLoading"
            :indeterminate="true"
            class="ma-0"
          />

          <v-card-text>
            <v-container
              grid-list-md
              class="pa-0"
            >
              <v-layout
                wrap
                class="form-group"
              >
                <v-flex xs12>
                  <h6 class="subheading">
                    Email Details
                  </h6>
                </v-flex>

                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="payoutIds"
                    label="Payout IDs"
                    disabled
                  />
                </v-flex>

                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="formData.subject"
                    label="Subject"
                    :error-messages="getFieldErrors('subject')"
                    @input="$v.formData.subject.$touch()"
                    @blur="$v.formData.subject.$touch()"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-textarea
                    v-model="formData.dynamic_text"
                    label="Dynamic Text"
                    rows="10"
                    :error-messages="getFieldErrors('dynamic_text')"
                    @input="$v.formData.dynamic_text.$touch()"
                    @blur="$v.formData.dynamic_text.$touch()"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-checkbox
                    v-model="formData.test_mode"
                    label="Enable TestMode. If enabled the system will send 3 random Holder Mails to your Mail-Account."
                    class="mt-3"
                    v-on="on"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-checkbox
                    v-model="formData.trustpilot_enabled"
                    label="Enable Trustpilot Rating in email"
                    class="mt-3"
                    v-on="on"
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <v-alert
              v-for="e in error"
              :key="e.path"
              :value="error"
              type="error"
              color="error"
            >
              {{ e.message }}
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="isVisible = false"
            >
              <v-icon>
                cancel
              </v-icon>
              Cancel
            </v-btn>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isLoading || $v.$invalid"
                  :loading="isLoading"
                  color="primary"
                  @click="submit"
                  v-on="on"
                >
                  <v-icon>
                    email
                  </v-icon>
                  Send
                </v-btn>
              </template>
              <span>Validate and submit</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
        <v-snackbar
          v-model="snackbarShow"
          :color="snackbarColor"
          :auto-height="true"
        >
          <ul v-if="snackbarErrors">
            <li
              v-for="snackbarError in snackbarErrors"
              :key="snackbarError.message"
            >
              {{ snackbarError.message }}
            </li>
          </ul>

          <div
            v-if="snackbarMessage"
          >
            {{ snackbarMessage }}
          </div>

          <v-btn
            color="primary"
            text
            @click="snackbarShow = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'SendEmailYieldDialog',
  components: {
  },
  props: {
    visible: Boolean,
    payoutIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      error: null,
      snackbarShow: false,
      snackbarMessage: '',
      snackbarColor: 'error',
      snackbarErrors: [],
      formData: {
        payout_id: null,
        test_mode: false,
        trustpilot_enabled: true,
      },
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  mounted() {
    this.formData = {
      ...this.formData,
      ...(this.serializePayout(this.payout)),
    };

    this.$v.$touch();
  },
  methods: {
    getFieldErrors(field) {
      const errors = [];
      const formField = this.$v.formData[field];

      if (formField) {
        if (!formField.$dirty || !formField.$invalid) {
          return errors;
        }

        if (!formField.required) {
          errors.push('Required field');
        }

        if (!formField.minLength) {
          errors.push('Field has a minimum length');
        }

        if (!formField.maxLength) {
          errors.push('Field has a maximum length');
        }
      }

      return errors;
    },
    serializePayout(payout) {
      const { ...serializePayout } = payout;

      return {
        ...serializePayout,
      };
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.isLoading = true;

      this.$store.dispatch('callYieldPayoutEmail', {
        payout_ids: this.payoutIds,
        subject: this.formData.subject,
        dynamic_text: this.formData.dynamic_text,
        test_mode: this.formData.test_mode,
        trustpilot_enabled: this.formData.trustpilot_enabled,
      })
        .then(() => {
          this.isLoading = false;
          this.isVisible = false;

          this.snackbarShow = true;
          this.snackbarErrors = [];
          this.snackbarMessage = 'Yield Email sending was triggered!';
          this.snackbarColor = 'success';
        })
        .catch((error) => {
          this.isLoading = false;

          this.snackbarShow = true;
          this.snackbarErrors = (error.response && error.response.data) ? error.response.data : 'Error';
          this.snackbarMessage = '';
          this.snackbarColor = 'error';
        });
    },
  },
  validations() {
    return {
      formData: {
        subject: { required },
        dynamic_text: { required },
      },
    };
  },
};
</script>

<style lang="scss">
.create-bridge-signing {
  .v-card__title {
    padding: 24px;
  }
  .v-card__text {
    max-height: 65vh;
    overflow: auto;
    padding-top: 32px;
  }
  .v-card__actions {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  .radio-label {
    position: absolute;
    font-size: 16px;
    text-align: left;
    max-width: 133%;
    height: 20px;
    left: 12px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.54);
    -webkit-transform: translateY(-18px) scale(0.75);
    transform: translateY(0px) translateX(-6px) scale(0.75);
  }
  .subheading {
    padding: 8px;
    background: white;
    color: rgba(0, 0, 0, 0.54);
    top: -20px;
    left: 8px;
    position: absolute;
    display: flex;
    align-items: center;
  }
  .form-group {
    padding: 16px;
    margin: 0 0 24px 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    position: relative;
  }
  .container.grid-list-md .layout:not(:only-child) {
    margin: 0 0 24px 0;
  }
  .v-input--selection-controls.v-input .v-label {
    text-transform: capitalize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/payoutEmail/SendEmailYieldDialog.vue